import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate, { Validator } from "vee-validate";
import it from "vee-validate/dist/locale/it";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { faListUl } from "@fortawesome/free-solid-svg-icons";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { faPause } from "@fortawesome/free-solid-svg-icons";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import panZoom from 'vue-panzoom';
import Embed from 'v-video-embed'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faUserSecret, faSpinner, faMap, faListUl, faQuestion, faChevronDown, faChevronUp, faChevronLeft, faPlay, faPause, faHome, faTrash)

Vue.config.productionTip = false


import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(panZoom);
Vue.use(Embed);

Vue.use(VeeValidate, { fieldsBagName: "veeFields" });
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize("it", it);

import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed);

//Utilizzo il recorder audio
//https://github.com/codekraft-studio/vue-record
import VueRecord from "@codekraft-studio/vue-record";
Vue.use(VueRecord);

import AudioRecorder from 'vue-audio-recorder';
Vue.use(AudioRecorder);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

const moment = require("moment");
require("moment/locale/it");

Vue.use(require("vue-moment"), {
  moment,
});

import "./custom.scss";
import "./corner-ribbon.css";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

//Inspired by
//https://bezkoder.com/jwt-vue-vuex-authentication/
